/**
 * Default copy for on-site popup — keep in sync with backend `src/i18n/onsite-popup-defaults.json`.
 */
import POPUP_DEFAULTS_BY_LOCALE from "./onsite-popup-defaults.json";

const SUPPORTED = ["it", "en", "de", "fr", "es"];

export function normalizePopupLocale(raw) {
  if (!raw || typeof raw !== "string") return "it";
  const base = raw.split("-")[0].toLowerCase();
  return SUPPORTED.includes(base) ? base : "it";
}

/** Defaults for merchant dashboard UI language (preview + placeholders when field is empty). */
export function getPopupDefaultsForDashboard(lang) {
  const k = normalizePopupLocale(lang);
  const row = POPUP_DEFAULTS_BY_LOCALE[k];
  if (row && typeof row === "object") return row;
  return POPUP_DEFAULTS_BY_LOCALE.en || POPUP_DEFAULTS_BY_LOCALE.it;
}

function buildCanonicalSets() {
  const titles = new Set();
  const bodies = new Set();
  const ctas = new Set();
  const dismisses = new Set();
  for (const loc of SUPPORTED) {
    const d = POPUP_DEFAULTS_BY_LOCALE[loc];
    if (!d || typeof d !== "object") continue;
    if (d.title_template) titles.add(String(d.title_template).trim());
    if (d.body_template) bodies.add(String(d.body_template).trim());
    if (d.cta_label) ctas.add(String(d.cta_label).trim());
    if (d.dismiss_label) dismisses.add(String(d.dismiss_label).trim());
  }
  return { titles, bodies, ctas, dismisses };
}

export const POPUP_CANONICAL_DEFAULT_SETS = buildCanonicalSets();

/** If DB holds exactly a platform default (any locale), show empty field + dashboard-locale placeholder. */
export function normalizeStoredAgainstCanonical(raw, canonicalSet) {
  if (raw == null) return "";
  const s = String(raw).trim();
  if (s === "") return "";
  if (canonicalSet.has(s)) return "";
  return s;
}
